import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';

import { KYMW7001Component } from './kymw7001.component';
import { ApprovalFeatureInfoService } from './api-services/approval-feature-info';
import { CheckFeatureGoodsSelectionService } from './api-services/check-feature-goods-selection';
import { CheckFeatureSelectionService } from './api-services/check-feature-selection.service';
import { ConfirmFeatureGoodsByBuyerService } from './api-services/confirm-feature-goods-by-buyer';
import { GetFeatureListService } from './api-services/get-feature-list.service';
import { GetFeatureThemaByBuyerService } from './api-services/get-feature-thema-by-buyer';
import { GetMediumListByOrderService } from './api-services/get-medium-list-by-order.service';
import { GetReplacementGoodsService } from './api-services/get-replacement-goods';
import { GetReplacementListService } from './api-services/get-replacement-list';
import { GetReplacementRequestGoodsService } from './api-services/get-replacement-request-goods';
import { GetSelectionGoodsListByBuyerService } from './api-services/get-selection-goods-list-by-buyer';
import { GetTargetListByFeatureGoodsSelectionService } from './api-services/get-target-list-by-feature-goods-selection.service';
import { RegistFeatureRequestBuyerService } from './api-services/regist-feature-request-buyer';
import { RejectionFeatureInfoService } from './api-services/rejection-feature-info';
import { GetGoodsPlanNumService } from './api-services/get-goods-plan-num.service';
import { GetCodeListService } from 'src/app/commons/kymw02/api-services/get-code-list.service';

/**
 * 表紙特集掲載商品選定（バイヤー）画面 モジュール設定クラス
 *
 * @export KYMW7001Module
 * @class KYMW7001Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjNavModule,
    WjGridModule,
    WjGridFilterModule
  ],
  declarations: [KYMW7001Component],
  providers: [
    ApprovalFeatureInfoService,
    CheckFeatureGoodsSelectionService,
    CheckFeatureSelectionService,
    ConfirmFeatureGoodsByBuyerService,
    GetFeatureListService,
    GetFeatureThemaByBuyerService,
    GetGoodsPlanNumService,
    GetMediumListByOrderService,
    GetReplacementGoodsService,
    GetReplacementListService,
    GetReplacementRequestGoodsService,
    GetSelectionGoodsListByBuyerService,
    GetTargetListByFeatureGoodsSelectionService,
    RegistFeatureRequestBuyerService,
    RejectionFeatureInfoService,
    GetCodeListService
  ],
})
export class KYMW7001Module {}
